import {
  faBarcode,
  faBrowser,
  faBuilding,
  faCalendar,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faClipboardList,
  faDatabase,
  faDoorOpen,
  faDraftingCompass,
  faFileCsv,
  faFileLines,
  faFilePdf,
  faFileSpreadsheet,
  faFolderGear,
  faFolderTree,
  faForklift,
  faGear,
  faHandshake,
  faHouse,
  faIdCard,
  faIdCardClip,
  faLayerPlus,
  faList,
  faMap,
  faMoneyCheckDollarPen,
  faMoneyCheckEdit,
  faMoneyCheckEditAlt,
  faMoneyCheckPen,
  faPenRuler,
  faPlus,
  faPrint,
  faRectangleList,
  faStar,
  faTable,
  faTriangleExclamation,
  faTruckClock,
  faTruckContainer,
  faTruckLoading,
  faTruckRamp,
  faUserHardHat,
  faVectorSquare
} from "@fortawesome/pro-light-svg-icons";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

export const SIDEBAR_ICONS: IconDefinition[] = [
  faHouse,
  faChevronRight,
  faChevronLeft,
  faChevronDown,
  faChevronUp,
  faCalendar,
  faStar,
  faGear,
  faTruckContainer,
  faTruckClock,
  faTruckLoading,
  faTruckRamp,
  faPenRuler,
  faHandshake,
  faFolderTree,
  faMap,
  faBarcode,
  faPlus,
  faForklift,
  faTable,
  faList,
  faClipboardList,
  faDoorOpen,
  faTriangleExclamation,
  faRectangleList,
  faIdCard,
  faPrint,
  faIdCardClip,
  faVectorSquare,
  faFilePdf,
  faMoneyCheckEditAlt,
  faBuilding,
  faBrowser,
  faUserHardHat,
  faDatabase,
  faMoneyCheckDollarPen,
  faMoneyCheckEdit,
  faMoneyCheckPen,
  faFileLines,
  faDraftingCompass,
  faFolderGear,
  faLayerPlus,
  faFileSpreadsheet,
  faFileCsv
];

